module.exports = __webpack_public_path__ + "static/media/Grøt.40f85e32.PNG";